import React, { useContext, useEffect, useState } from "react";
import { AnalisisCreditoContext } from "../AnalisisCreditoScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { ModalSolicitudCredito } from "../Modales/ModalSolicitudCredito";
import MdlSolicitudCreditoScreen from "../Modales/MdlSolicitudCreditoScreen";
import MdlValidacionPedido from "../Modales/MdlValidacionPedido";
import MdlAnalisisSolicitud from "../Modales/MdlAnalisisSolicitud";
import MdlDictamen from "../Modales/MdlDictamen";
import MdlEnganche from "../Modales/MdlEnganche";
import MdlFacturacion from "../Modales/MdlFacturacion";
import TimeLineTarget from "../TimeLine/TimeLineTarget";
import ComputerIcon from "@mui/icons-material/Computer";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import MdlAnalisisOtorgamientoCredito from "../Modales/MdlAnalisisOtorgamientoCredito";
import MdlReporteCampo from "../Modales/MdlReporteCampo";
import MdlCondicionesLineaCredito from "../Modales/MdlCondicionesLineaCredito";
import { MdlConvocatoriaComiteCredito } from "../Modales/MdlConvocatoriaComiteCredito";
import { MdlVerificacionCondicionesCredito } from "../Modales/MdlVerificacionCondicionesCredito";
import { AnalisisComentariosLine } from "../AnalisisComentariosLine";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";

export const OperacionComiteCredito = ({ data, estado, upload, direccion }) => {
  const { state } = useContext(AnalisisCreditoContext);
  const [openSolicitud, setOpenSolicitud] = useState(false);
  const [comentarios, setComentario] = useState([]);
  const [value, setValue] = useState(0);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  useEffect(() => {
    onActualizarComentarios();
  }, []);

  const onActualizarComentarios = () => {
    if (
      state.folio === undefined ||
      state.folio === null ||
      state.folio.length !== 13
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`AnalisisSolicitudCreditoComentarios/Listado?folio=${state.folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setComentario(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITU", JSON.stringify(error), "error");
      });
  };
  return (
    <PlantillaScreen
      titulo={"AUTORIZACION DE CREDITO DE LINEA DE OPERACION"}
      className={"analisis-sc-procesos"}
    >
      <LoaderScreen loader={loader} />
      <ModalSolicitudCredito
        open={openSolicitud}
        setOpenSolicitud={setOpenSolicitud}
        value={value}
        setValue={setValue}
        upload={upload}
        maxValue={Number(estado.pantallacompleta)}
        screens={{
          screen0: (
            <MdlSolicitudCreditoScreen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen1: (
            <MdlValidacionPedido
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen2: (
            <MdlConvocatoriaComiteCredito
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen3: (
            <MdlAnalisisSolicitud
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen4: (
            <MdlAnalisisOtorgamientoCredito
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen5: (
            <MdlReporteCampo
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen6: (
            <MdlCondicionesLineaCredito
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen7: (
            <MdlVerificacionCondicionesCredito
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen8: (
            <MdlDictamen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen9: (
            <MdlEnganche
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen10: (
            <MdlFacturacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
        }}
        titulos={{
          screen0: "SOLICITUD DE CREDITO",
          screen1: "VALIDAR PEDIDO",
          screen2: "CONVOCAR A COMITE",
          screen3: "ANALIZAR SOLICITUD",
          screen4: "OTORGAR CREDITO",
          screen5: "REPORTE DE CAMPO",
          screen6: "VALIDAR CONDICIONES CREDITO",
          screen7: "VALIDAR CUMPLIMIENTO DE LAS CONDICIONES",
          screen8: "DICTAMEN",
          screen9: "VALIDAR ENGANCHE",
          screen10: "FACTURAR EQUIPO",
        }}
      />
      <div className="analisis-sc-procesos-timeline-title ">
        {state.cliente}
      </div>
      <div className="analisis-sc-procesos-timeline scroll-4">
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Genero Solicitud"}
          subtitle={"Vendedor"}
          footer={{
            tiempoestimado: data[0].estado,
            leyenda: data[0].creado,
            duracion: data[0].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[0].control}
          active={1 === Number(estado.pantallacompleta)}
          value={0}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Validar Pedido"}
          subtitle={"Gerente de Sucursal"}
          footer={{
            tiempoestimado: data[1].estado,
            leyenda: data[1].creado,
            duracion: data[1].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[1].control}
          active={2 === Number(estado.pantallacompleta)}
          value={1}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Convocar a Comite"}
          subtitle={"Secretario de Comité"}
          footer={{
            tiempoestimado: data[2].estado,
            leyenda: data[2].creado,
            duracion: data[2].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[2].control}
          active={3 === Number(estado.pantallacompleta)}
          value={2}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ManageSearchIcon />}
          title={"Analizar solicitud"}
          subtitle={"Coordinador de Crédito"}
          footer={{
            tiempoestimado: data[3].estado,
            leyenda: data[3].creado,
            duracion: data[3].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[3].control}
          active={4 === Number(estado.pantallacompleta)}
          value={3}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Otorgar Credito"}
          subtitle={"Coordinador de Crédito"}
          footer={{
            tiempoestimado: data[4].estado,
            leyenda: data[4].creado,
            duracion: data[4].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[4].control}
          active={5 === Number(estado.pantallacompleta)}
          value={4}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Reporte de Campo"}
          subtitle={"Coordinación de Crédito"}
          footer={{
            tiempoestimado: data[5].estado,
            leyenda: data[5].creado,
            duracion: data[5].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[5].control}
          active={6 === Number(estado.pantallacompleta)}
          value={5}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Condicion de Crédito"}
          subtitle={"Coordinador de Crédito"}
          footer={{
            tiempoestimado: data[6].estado,
            leyenda: data[6].creado,
            duracion: data[6].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[6].control}
          active={7 === Number(estado.pantallacompleta)}
          value={6}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Validar Condiciones"}
          subtitle={"Coordinación de Crédito"}
          footer={{
            tiempoestimado: data[7].estado,
            leyenda: data[7].creado,
            duracion: data[7].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[7].control}
          active={8 === Number(estado.pantallacompleta)}
          value={7}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<FactCheckIcon />}
          title={"Dictamen"}
          subtitle={"Coordinación de Crédito"}
          footer={{
            tiempoestimado: data[8].estado,
            leyenda: data[8].creado,
            duracion: data[8].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[8].control}
          active={9 === Number(estado.pantallacompleta)}
          value={8}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Validar Enganche"}
          subtitle={"Ventas"}
          footer={{
            tiempoestimado: data[9].estado,
            leyenda: data[9].creado,
            duracion: data[9].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[9].control}
          active={10 === Number(estado.pantallacompleta)}
          value={9}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<RequestPageIcon />}
          title={"Facturar Equipo"}
          subtitle={"Ventas"}
          footer={{
            tiempoestimado: data[10].estado,
            leyenda: data[10].creado,
            duracion: data[10].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          endtarget={true}
          color={data[10].control}
          active={11 === Number(estado.pantallacompleta)}
          value={10}
          setValue={setValue}
        />
      </div>
      <AnalisisComentariosLine
        tiempotranscurrido={estado.tiempotranscurrido}
        tiempoestimado={estado.tiempoestimado}
        comentarios={comentarios}
      />
    </PlantillaScreen>
  );
};
